// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-B5Tn2B","body":"body-inPwpU","infoButton":"infoButton-hBdwiy"};